<template>
    <b-modal ref="mdlFlussiEdit" :title="'Genera Flusso'" size="lg" hide-header-close no-close-on-backdrop no-close-on-esc centered scrollable>
        <b-row>
            <!--      <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Flusso</label>
                <b-select :options="flussiptions" v-model="jsonData.codiceFlusso" :disabled="readOnly" value-field="codice" text-field="descrizione">
                    <template #first>
                        <b-select-option :value="''" disabled> - Seleziona Flusso - </b-select-option>
                    </template>
                </b-select>
            </b-col> -->
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label_data">Mese Anno Riferimento</label>
                <date-picker v-model="jsonData.meseAnnoRiferimento" format="MM-YYYY" value-type="timestamp" type="month"></date-picker>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label>Struttura</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.idStruttura" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="id" text-field="denominazione" :options="strutturaOptions" @change="onChangeStruttura"></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label>Presidi</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.idPresidio" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="id" text-field="denominazione" :options="presidiOptions" @change="onChangePresidio"></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label>Regime</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.regime" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="idRsaSettings" text-field="setting" :options="settingsPresidiOptions"></b-form-select>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button size="md" variant="outline-success" @click="onClickOk()">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import axios from "axios";
import DatePicker from "vue2-datepicker";

export default {
    mixins: [UtilityMixin],
    components: { ModalError, DatePicker },
    data() {
        return {
            title: null,
            pathResource: "/flussifatturaanticipata",
            pathResourceFlussiTipi: "/flussitipi",
            pathResourceStrutture: "/strutture",
            pathResourcePresidi: "/strutturepresidi",
            pathResourceSettingsPresidi: "/rsasettingspresidi",
            readOnly: false,
            jsonData: { meseAnnoRiferimento: null, idStruttura: "", idPresidio: "", regime: "" },
            lookPassword: false,
            flussiptions: [],
            strutturaOptions: [{ id: "", denominazione: "- Seleziona Struttura -" }],
            presidiOptions: [{ id: "", denominazione: "-Seleziona Presidio-" }],
            settingsPresidiOptions: [{ idRsaSettings: "", setting: "-Seleziona regime-" }],
        };
    },
    methods: {
        show() {
            let me = this;
            me.jsonData = { meseAnnoRiferimento: null, idStruttura: "", idPresidio: "", regime: "" };
            me.loadTipiFlussi();
            me.loadStrutture();
            me.$refs.mdlFlussiEdit.show();
        },
        loadStrutture() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceStrutture;
            axios
                .get(link)
                .then((response) => {
                    me.strutturaOptions = [];
                    me.rows = response.data.data.recordsNumber;
                    me.strutturaOptions = response.data.data;

                    if (me.strutturaOptions.length === 1) {
                        me.jsonData.idStruttura = me.strutturaOptions[0].id;
                        me.loadPresidi(me.strutturaOptions[0].id);
                    } else {
                        me.strutturaOptions.unshift({
                            idStruttura: "",
                            denominazione: "-Seleziona Struttura-",
                        });
                    }
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        loadPresidi(value) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcePresidi;
            me.presidiOptions = [];
            me.filtroPresidi = { idStruttura: value };
            axios
                .get(link, { params: me.filtroPresidi })
                .then((response) => {
                    me.presidiOptions = response.data.data.list;
                    if (me.presidiOptions.length === 1) {
                        me.jsonData.idPresidio = me.presidiOptions[0].id;
                        me.loadSettingsPresidi(me.jsonData.idPresidio);
                    } else {
                        //  me.jsonData.idPresidio = null;
                        me.presidiOptions.unshift({
                            id: "",
                            denominazione: "-Seleziona Presidio-",
                        });
                    }
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        loadSettingsPresidi(id) {
            let me = this;
            let params = { idPresidio: id };
            UtilityMixin.methods.loadDataResources(me.pathResourceSettingsPresidi, params, me.resultResponseSettings, me.resultErrorSettings);
        },
        resultResponseSettings(response) {
            let me = this;
            me.settingsPresidiOptions = response.data.data.list;
            if (me.settingsPresidiOptions.length === 1) {
                me.jsonData.regime = me.settingsPresidiOptions[0].idRsaSettings;
            } else {
                me.settingsPresidiOptions.unshift({ idRsaSettings: "", setting: "-Seleziona Setting-" });
            }
        },
        resultErrorSettings(response) {
            UtilityMixin.methods.messaggeBoxError(this, response);
        },
        onChangeStruttura(value) {
            let me = this;
            // me.strutturaOptions.forEach((element) => {
            //     if (element.codiceStruttura === value) {
            me.loadPresidi(value);
            // }
            // });
        },
        onChangePresidio(value) {
            let me = this;
            me.loadSettingsPresidi(value);
            //me.presidiOptions.forEach((element) => {
            //   if (element.id === value) {
            //   }
            // });
        },
        loadTipiFlussi() {
            let me = this;
            me.flussiptions = [];
            UtilityMixin.methods.loadDataResources(me.pathResourceFlussiTipi, null, me.loadTipiFlussiSuccess, me.loadTipiFlussiError);
        },
        loadTipiFlussiSuccess(response) {
            let me = this;
            me.flussiptions = response.data.data.list;
        },
        loadTipiFlussiError(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onCloseModal() {
            let me = this;
            me.jsonData = {};
            me.$refs.mdlFlussiEdit.hide();
        },
        onClickOk() {
            let me = this;
            this.saveResource(me.pathResource + "/genera", me.jsonData, me.saveResponseSuccess, me.saveResponseError);
        },
        saveResponseSuccess(response) {
            let me = this;
            me.$refs.mdlFlussiEdit.hide();
            me.$bvToast.toast("Operazione andata a buon fine", {
                title: "Successo",
                variant: "Success",
                solid: true,
            });
            me.$emit("afterSave", response);
        },

        saveResponseError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
    },
};
</script>

<style></style>
